var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragandDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#F2FBFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.1973,
    y: 39.0117,
    width: 33.6046,
    height: 23.5581,
    rx: 3.5,
    fill: "#ADE8F4",
    stroke: "#48CAE4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.372,
    y: 37.3405,
    width: 21.3256,
    height: 26.3488,
    rx: 1.5,
    transform: "rotate(-27.5845 31.372 37.3405)",
    fill: "white",
    stroke: "#48CAE4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.8447,
    y: 45.9888,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-27.5845 37.8447 45.9888)",
    fill: "#ADE8F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9688,
    y: 38.5684,
    width: 7.81396,
    height: 1.11628,
    transform: "rotate(-27.5845 33.9688 38.5684)",
    fill: "#CAF0F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7432,
    y: 40.0527,
    width: 17.8605,
    height: 1.11628,
    transform: "rotate(-27.5845 34.7432 40.0527)",
    fill: "#CAF0F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8789,
    y: 47.9678,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-27.5845 38.8789 47.9678)",
    fill: "#ADE8F4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9131,
    y: 49.9468,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-27.5845 39.9131 49.9468)",
    fill: "#ADE8F4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9463,
    y: 51.9253,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-27.5845 40.9463 51.9253)",
    fill: "#ADE8F4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 41.9805,
    y: 53.9043,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-27.5845 41.9805 53.9043)",
    fill: "#ADE8F4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 43.0137,
    y: 55.8828,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-27.5845 43.0137 55.8828)",
    fill: "#ADE8F4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2871,
    y: 43.146,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-27.5845 43.2871 43.146)",
    fill: "#ADE8F4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 5.5814,
    height: 1.67442,
    transform: "matrix(0.886329 -0.463056 0.463057 0.886328 44.3203 45.125)",
    fill: "#ADE8F4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 5.58139,
    height: 1.67442,
    transform: "matrix(0.886328 -0.463057 0.463056 0.886329 45.3545 47.1035)",
    fill: "#ADE8F4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3877,
    y: 49.0825,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-27.5845 46.3877 49.0825)",
    fill: "#ADE8F4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4219,
    y: 51.061,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-27.5845 47.4219 51.061)",
    fill: "#ADE8F4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 48.4561,
    y: 53.04,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-27.5845 48.4561 53.04)",
    fill: "#ADE8F4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 5.5814,
    height: 1.67442,
    transform: "matrix(0.886329 -0.463056 0.463057 0.886328 48.7285 40.3032)",
    fill: "#ADE8F4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 49.7617,
    y: 42.2817,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-27.5845 49.7617 42.2817)",
    fill: "#ADE8F4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 5.58139,
    height: 1.67442,
    transform: "matrix(0.886329 -0.463056 0.463058 0.886328 50.7959 44.2607)",
    fill: "#ADE8F4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 5.5814,
    height: 1.67442,
    transform: "matrix(0.886329 -0.463056 0.463057 0.886328 51.8301 46.2393)",
    fill: "#ADE8F4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8633,
    y: 48.2183,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-27.5845 52.8633 48.2183)",
    fill: "#ADE8F4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8975,
    y: 50.1968,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-27.5845 53.8975 50.1968)",
    fill: "#ADE8F4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6728,
    y: 33.1927,
    width: 21.3256,
    height: 26.3488,
    rx: 1.5,
    transform: "rotate(-17.279 34.6728 33.1927)",
    fill: "white",
    stroke: "#ADE8F4"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 39.4941,
    y: 42.8599,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-17.279 39.4941 42.8599)",
    fill: "#ADE8F4"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0078,
    y: 34.8652,
    width: 7.81395,
    height: 1.11628,
    transform: "rotate(-17.279 37.0078 34.8652)",
    fill: "#CAF0F8"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5049,
    y: 36.4644,
    width: 17.8605,
    height: 1.11628,
    transform: "rotate(-17.279 37.5049 36.4644)",
    fill: "#CAF0F8"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1572,
    y: 44.9917,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-17.279 40.1572 44.9917)",
    fill: "#ADE8F4"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 5.58139,
    height: 1.67442,
    transform: "matrix(0.954869 -0.297026 0.297025 0.95487 40.8203 47.123)",
    fill: "#ADE8F4"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4834,
    y: 49.2549,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-17.279 41.4834 49.2549)",
    fill: "#ADE8F4"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1465,
    y: 51.3867,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-17.279 42.1465 51.3867)",
    fill: "#ADE8F4"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8096,
    y: 53.5186,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-17.279 42.8096 53.5186)",
    fill: "#ADE8F4"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3564,
    y: 41.0361,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-17.279 45.3564 41.0361)",
    fill: "#ADE8F4"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0195,
    y: 43.168,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-17.279 46.0195 43.168)",
    fill: "#ADE8F4"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6826,
    y: 45.2998,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-17.279 46.6826 45.2998)",
    fill: "#ADE8F4"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 47.3457,
    y: 47.4316,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-17.279 47.3457 47.4316)",
    fill: "#ADE8F4"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0088,
    y: 49.5635,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-17.279 48.0088 49.5635)",
    fill: "#ADE8F4"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 5.5814,
    height: 1.67442,
    transform: "matrix(0.954869 -0.297026 0.297024 0.95487 48.6729 51.6948)",
    fill: "#ADE8F4"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2188,
    y: 39.2124,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-17.279 51.2188 39.2124)",
    fill: "#ADE8F4"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 51.8828,
    y: 41.3442,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-17.279 51.8828 41.3442)",
    fill: "#ADE8F4"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5459,
    y: 43.4761,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-17.279 52.5459 43.4761)",
    fill: "#ADE8F4"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 53.209,
    y: 45.6079,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-17.279 53.209 45.6079)",
    fill: "#ADE8F4"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8721,
    y: 47.7397,
    width: 5.58139,
    height: 1.67442,
    transform: "rotate(-17.279 53.8721 47.7397)",
    fill: "#ADE8F4"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 49.8716,
    width: 5.5814,
    height: 1.67442,
    transform: "rotate(-17.279 54.5352 49.8716)",
    fill: "#ADE8F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4707 51.2812C29.2333 49.2043 30.8576 47.3838 32.948 47.3838H39.7327C40.1562 47.3838 40.5763 47.4607 40.9724 47.6107L45.4635 49.3119C45.9728 49.5048 46.5129 49.6037 47.0575 49.6037H63.3964C65.5517 49.6037 67.1948 51.5328 66.8518 53.6606L65.3505 62.9756C65.0772 64.6717 63.6131 65.9187 61.8951 65.9187H34.2663C32.4871 65.9187 30.991 64.5838 30.7889 62.8161L29.4707 51.2812Z",
    fill: "#ADE8F4",
    stroke: "#48CAE4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_87369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2322 32.0932C47.3298 32.0933 46.4182 30.4188 46.3252 29.5816L49.9531 28.4653L50.2322 32.0932Z",
    fill: "#CAF0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1622 29.3023C46.9389 28.8557 47.7203 27.9069 47.7203 27.9069L47.7203 27.3488C47.8744 26.7288 48.3427 26.7184 48.5575 26.7907C49.004 26.3442 49.4878 26.4186 49.6738 26.5116C50.1203 26.0651 50.604 26.1396 50.7901 26.2326C51.2366 26.0094 51.7203 26.1396 51.9064 26.2326L52.4645 27.3489C53.1343 28.9117 53.1157 30.4187 53.0226 30.9768L50.7901 32.0931C48.2785 31.814 47.4413 29.8605 47.1622 29.3023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2786 30.6978C48.111 30.4063 49.2492 30.55 49.2492 30.55C49.2492 30.55 49.3948 30.2875 50.5111 30.6978C50.7902 30.6978 51.0693 30.55 51.9065 30.1397C52.2417 29.8481 51.9443 29.5979 52.1855 28.4653C52.5207 28.1737 52.0459 26.7301 52.1855 26.7909C52.5207 26.6451 52.604 28.1255 52.7437 28.1862C52.8135 28.3077 52.8551 28.6187 53.0227 28.9102C53.5256 29.9306 53.0926 30.8916 53.0227 31.256L51.0693 32.0932C49.1837 31.911 48.4881 31.0623 48.2786 30.6978Z",
    fill: "#CAF0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1935 25.8075C51.1084 25.8489 51.0299 25.9026 50.9606 25.9669C50.793 25.7166 50.4015 25.6506 50.0275 25.8257C49.9123 25.8751 49.8079 25.9464 49.7202 26.0359C49.5969 25.9484 49.4515 25.8973 49.3006 25.8883C49.1497 25.8793 48.9993 25.9127 48.8664 25.9848C48.7446 26.0354 48.6365 26.1143 48.5514 26.2151C48.4662 26.3158 48.4063 26.4355 48.3767 26.5641C48.2178 26.5486 48.0577 26.5767 47.9137 26.6456C47.7351 26.7152 47.591 26.852 47.5122 27.0267C47.4333 27.2014 47.4261 27.4001 47.4921 27.58L47.5848 27.7779C47.395 27.9728 46.8742 28.5878 47.0097 29.3304C47.1452 30.0729 47.8981 31.0355 48.794 31.6184C49.3883 31.9931 50.0433 32.2616 50.7297 32.4117C50.7746 32.4202 50.821 32.4143 50.8623 32.3947L53.111 31.342C53.154 31.3213 53.1892 31.2872 53.2112 31.2447C53.4333 30.702 53.4996 30.1081 53.4027 29.5298C53.334 28.7408 53.1146 27.9723 52.7565 27.2658L52.1965 26.0697C52.0971 25.9033 51.9362 25.7825 51.7486 25.7334C51.561 25.6844 51.3617 25.711 51.1935 25.8075ZM52.365 27.4491C52.706 28.1158 52.9138 28.8425 52.9768 29.5886C53.0465 30.0578 53.0035 30.5369 52.8516 30.9862L50.7356 31.9768C50.1293 31.8338 49.5506 31.5924 49.0223 31.2622C48.1139 30.6641 47.532 29.7778 47.4252 29.2551C47.4083 29.0646 47.4315 28.8726 47.4934 28.6916C47.5552 28.5106 47.6543 28.3445 47.7843 28.2042L48.5631 29.8678C48.5874 29.9198 48.6314 29.9599 48.6852 29.9794C48.7391 29.9989 48.7986 29.9962 48.8505 29.9719C48.9024 29.9476 48.9425 29.9037 48.962 29.8498C48.9816 29.7959 48.9789 29.7365 48.9546 29.6846L47.8836 27.3967C47.8357 27.2945 47.9101 27.1192 48.0993 27.0306C48.2885 26.9421 48.4763 26.992 48.5251 27.0964L49.1075 28.3404L49.4989 28.1571L48.8066 26.6783C48.7781 26.6174 48.8605 26.4648 49.0519 26.3752C49.2432 26.2856 49.4335 26.3239 49.461 26.3826L50.1624 27.881L50.5539 27.6977L49.9695 26.4494L49.9942 26.406C50.0485 26.322 50.1264 26.2559 50.2183 26.2163C50.4205 26.1216 50.5893 26.1593 50.6137 26.2115L51.2755 27.6251L51.6691 27.4408L51.1733 26.3817C51.2222 26.2994 51.2956 26.2344 51.3833 26.1959C51.5703 26.1083 51.7658 26.1521 51.8095 26.2456L52.365 27.4491Z",
    fill: "#00B4D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_87369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.64453,
    height: 8.64454,
    fill: "white",
    transform: "translate(44.0928 26.5488) rotate(-25.0858)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragandDrop);
export default __webpack_public_path__ + "static/media/DragandDrop.f134cc4da0562e58ff269fd16dfedf1b.svg";
export { ForwardRef as ReactComponent };